const userHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "User Name",
    key: "UserName",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Email",
    key: "UserEmail",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "UserMobile",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "City",
    width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Role",
    key: "RoleName",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-96 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "actionWithOutInactive",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const itemsHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Items Type",
    key: "ItemType",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Items Categories",
    key: "ItemCategory",
    width: "md:w-44 lg:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Items Name",
    key: "ItemName",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:mw-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Description",
    key: "Description",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const socialMarketingHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
  },
  {
    title: "Social Marketing Categories",
    key: "CommodityCategory_en",
    width: "md:w-48 lg:w-48 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Social Marketing Name",
    key: "CommodityName_en",
    width: "md:w-40 lg:w-40 xl:w-48 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  // {
  //   title: "U.O.M",
  //   key: "CommodityUOM",
  //   width: "md:w-20 lg:w-20 xl:w-28 2xl:m-auto px-1 py-1.5 ",
  //   width1: "text-red-500",
  // },
  {
    title: "Description",
    key: "Description_en",
    width: "md:w-20 lg:w-80  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];

const medicinesDrugsHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
  },
  {
    title: "Medicines Category",
    key: "CommodityCategory_en",
    width: "md:w-36 lg:w-36 xl:w-48 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Medicines / Drugs Name",
    key: "CommodityName_en",
    width: "md:w-44 lg:w-44 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Route",
    key: "ModeName",
    width: "md:w-24 lg:w-20 xl:w-32 2xl:w-32 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  // {
  //   title: "U.O.M",
  //   key: "CommodityUOM",
  //   width: "md:w-16 lg:w-18 xl:w-24 2xl:m-auto px-1 py-1.5 ",
  //   width1: "text-red-500",
  // },
  {
    title: "Description",
    key: "Description_en",
    width: "md:w-20 lg:w-60  xl:w-72 2xl:w-72 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const consumablesHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12 px-1 py-1.5  ",
  },
  {
    title: "Consumables Categories",
    key: "CommodityCategory",
    width: "md:w-48 lg:w-48 xl:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Consumables Name",
    key: "CommodityName",
    width: "md:w-40 lg:w-40 xl:w-48 2xl:w-48 px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Description",
    key: "Description",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1 py-1.5 2xl:m-auto",
  },
];
const roomTypeHeader = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Room Type",
    key: "RoomType",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Location",
    key: "Location",
    width: "md:w-28 lg:w-24 xl:w-30 2xl:w-96 px-1 py-1.5 -ml-2",
    width1: "text-red-500",
  },
  {
    title: "Maximum Occupancy",
    key: "MaxOccupancy",
    width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Size",
    key: "Size",
    width: "md:w-20 lg:w-40 xl:w-50 2xl:w-96 px-1 py-1.5 ml-4",
    width1: "text-red-500",
  },
  {
    title: "Tariff",
    key: "Tariff",
    width: "md:w-20 lg:w-20 xl:w-30 2xl:w-96 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Amenities",
    key: "Amenities",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-96 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const RoomTypeHeader = [
  {
    title: "S.No.",
    width: "w-12 md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Photo",
    key: "userImage",
    width: "w-16 md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomType",
    width: "w-32 md:w-48 lg:w-52 xl:w-36 2xl:w-40 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "No of Rooms",
    key: "NoOfRooms",
    width:
      "w-28 md:w-20 lg:w-24 xl:w-24 2xl:w-24 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Size in Sq.ft",
    key: "Size",
    width:
      "w-28 md:w-24 lg:w-24 xl:w-28 2xl:w-28 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Max. Occupancy",
    key: "MaxOccupancy",
    width:
      "w-64 md:w-24 lg:w-24 xl:w-32 2xl:w-32 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description",
    width:
      " md:w-28 lg:w-32 xl:w-80 2xl:w-32 px-1 py-1.5 mr-auto whitespace-pre-line",
  },
  {
    title: "Action",
    key: "action",
    width: "w-64 md:w-16 lg:w-16 xl:w-12 2xl:w-32 px-1 py-1.5 ",
  },
];

// const RoomTypeHeader = [
//   {
//     title: "S.No.",
//     width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5  ",
//     width1: "text-red-500",
//   },

//   {
//     title: "Photo",
//     key: "userImage",
//     width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Room Type",
//     key: "RoomType",
//     width: "md:w-48 lg:w-60 xl:w-36 2xl:m-auto px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "No of Rooms",
//     key: "NoOfRooms",
//     width: "md:w-48 lg:w-60 xl:w-20 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
//     width1: "text-red-500",
//   },

//   {
//     title: "Size in Sq.ft",
//     key: "Size",
//     width: "md:w-48 lg:w-60 xl:w-20 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
//     width1: "text-red-500",
//   },
//   {
//     title: "Max. Occupancy",
//     key: "MaxOccupancy",
//     width: "md:w-96 lg:w-96 xl:w-24 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
//     width1: "text-red-500",
//   },
//   {
//     title: "Description",
//     key: "Description",
//     width: "flex-1 px-1 py-1.5 mr-2 line-clamp-3 overflow-hidden text-left",
//   },

//   {
//     title: "Action",
//     key: "action",
//     width: "px-1.5 py-1.5 flex justify-center md:w-16",
//   },
// ];
const reportCardMailHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Value Chain Partner",
    key: "PartnerName",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Company",
    key: "MstCompanyNames",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "View Report",
    key: "Report",
    width: "md:w-28 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "actionWithOutInactive",
    width: "md:w-16 px-1 py-1.5 flex justify-center",
    width1: "text-red-500",
  },
];

const partnermapingHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Company",
    key: "PartnerName",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Value Chain Partner",
    key: "ValueChainPartnerNames",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "actionWithOutInactive",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];

const supplierMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Supplier Id",
    key: "SupplierId",
    width: "md:w-28 lg:w-28 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Supplier Name",
    key: "SupplierName",
    width: "md:w-28 lg:w-28 xl:w-52 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "City",
    width: "md:w-28 lg:w-28 xl:w-52 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "SupplierMobileNumber",
    width: "md:w-28 lg:w-28 xl:w-52 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "SupplierEmailId",
    width: "md:w-28 lg:w-28 xl:w-80 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
// const customersMasterHeader = [
//   {
//     title: "S.No.",
//     key: "sno",
//     width: "md:w-12 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },

//   {
//     title: "Customer Id",
//     key: "CustomerId",
//     width: "md:w-32 lg:w-32 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Customer Name",
//     key: "CustomerName",
//     width: "md:w-28 lg:w-28 xl:w-52 2xl:flex-1 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "City",
//     key: "City",
//     width: "md:w-28 lg:w-28 xl:w-52 2xl:flex-1 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Mobile",
//     key: "ContactNumber",
//     width: "md:w-28 lg:w-28 xl:w-28 2xl:flex-1 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },

//   {
//     title: "Email",
//     key: "EmailId",
//     width: "md:w-36 lg:w-40 xl:w-96 2xl:flex-1 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Action",
//     key: "action",
//     width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
//   },
// ];
const reportCardMailMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Customer",
    key: "",
    width: "md:w-44 lg:w-44 xl:w-52 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Suppliers",
    key: "",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const customerMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Customer Id",
    key: "CustomerId",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Customer Name",
    key: "CustomerName",
    width: "md:w-32 lg:w-32 xl:w-44 2xl:m-auto 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "City",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "ContactNumber",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "EmailId",
    width: "md:w-32 lg:w-28 xl:w-60 2xl:m-auto 2xl:w-48 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const roleMasterHeader = [
  {
    title: "S.No.",
    key: "MstRoleId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Role / Group",
    key: "RoleName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "RoleDiscription",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const questionsMasterHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic #",
    key: "TopicNumber",
    width: "md:w-16 lg:w-16 xl:w-16 2xl:w-16 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic Name",
    key: "TopicName",
    width: "md:w-32 lg:w-32 xl:w-52 2xl:w-52 2xl:w-80 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question #",
    key: "QuestionNumber",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question",
    key: "Question",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-96  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center",
  },
];
const questionsDownloadHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic #",
    key: "TopicNumber",
    width: "md:w-16 lg:w-16 xl:w-16 2xl:w-16 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic Name",
    key: "TopicName",
    width: "md:w-32 lg:w-32 xl:w-52 2xl:w-52 2xl:w-80 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question #",
    key: "QuestionNumber",
    width: "md:w-20 lg:w-20 xl:w-20 whitespace-pre-line 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question",
    key: "Question",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-96  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Guidance",
    key: "Guidance",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
];
const topicMasterHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-16 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic No.",
    key: "TopicNo",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic Name",
    key: "TopicName",
    width: "md:w-32 lg:w-56 xl:w-72 2xl:m-auto 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-16 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const downloadQuestionsAnswerHeader = [
  {
    title: "S.No.",
    key: "",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module",
    key: "ModuleName",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic No.",
    key: "TopicNo",
    width: "md:w-16 lg:w-16 xl:w-20 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Topic",
    key: "TopicName",
    width: "md:w-32 lg:w-44 xl:w-52 2xl:w-52 2xl:w-80 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question No.",
    key: "QuestionNumber",
    width: "md:w-20 lg:w-20 xl:w-24 whitespace-pre-line 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Question",
    key: "Question",
    width: "md:w-40 lg:w-44  xl:w-72 2xl:w-80  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Attachments",
    key: "Attachment",
    width: " flex justify-center px-1 py-1.5 pr-5 ",
  },
];

const downloadAttachmentHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Questions No.",
    key: "QuestionsNo",
    width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Questions",
    key: "Questions",
    width: "md:w-60 lg:w-72 xl:w-96 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Answer No.",
    key: "AnswerNo",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Attachment",
    key: "Attachment",
    width: " md:w-44 px-1 py-1.5 ",
    width1: "text-red-500",
  },
];
const moduleHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Module Name",
    key: "ModuleName",
    width: "md:w-48 lg:w-54 xl:w-80  px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Relevance",
    key: "RelevanceApplicability",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-48 lg:w-54 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const partnerMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Partner Id",
    key: "PartnerId",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Partner Name",
    key: "PartnerName",
    width: "md:w-32 lg:w-32 xl:w-44 2xl:m-auto 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "LocationName_en",
    width: "md:w-24 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "PartnerMobileNumber",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "PartnerEmailId",
    width: "md:w-32 lg:w-28 xl:w-60 2xl:m-auto 2xl:w-48 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const paymentInfoHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 mt-1.5 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Client Name",
    key: "ClientName",
    width:
      "md:w-24 mt-1.5 lg:w-40 xl:w-40 2xl:m-auto whitespace-pre-line truncate px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Payment Date",
    key: "PaymentDate",
    width:
      "md:w-28 mt-1.5 lg:w-28 xl:w-28 whitespace-pre-line truncate 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Bank",
    key: "Bank",
    width:
      "md:w-32 mt-1.5 lg:w-32 xl:w-32 truncate whitespace-pre-line break-words 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Amount",
    key: "Amount",
    width: "md:w-20 mt-1.5 lg:w-20 xl:w-20 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Reference No.",
    key: "ReferenceNumber",
    width:
      "md:w-32 mt-1.5 whitespace-pre-line truncate  2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Payment Method",
    key: "PaymentMethod",
    width:
      "md:w-32 mt-1.5 lg:w-36 xl:w-36 whitespace-pre-line  2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Proforma Invoice",
    key: "ProformaInvoice",
    width: "md:w-24 mt-1.5  whitespace-pre-line  2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Tax Invoice",
    key: "TaxInvoice",
    width:
      "md:w-24 mt-1.5 whitespace-pre-line  2xl:m-auto px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "PaymentInfoAction",
    width: " px-1 py-1.5 pr-5 w-16",
  },
];

const tariffMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Photo",
    key: "Photo",
    width: "md:w-20  px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Room Type",
    key: "RoomType",
    key: "RoomTypeName",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  //  {
  //   title: "Base Tariff",
  //   key: "BaseTariff",
  //   width: "md:w-36 2xl:flex-1 px-1 py-1.5 m-auto",
  //   width1: "text-red-500",
  // },
  {
    title: "Base Tariff",
    key: "BaseTariff",
    width: "md:w-20 lg:w-24 xl:w-28 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Holiday Tariff",
    key: "HolidayTariff",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  // {
  //   title: "Special Tariff",
  //   key: "SpecialTariff",
  //   width:
  //     "md:w-24 lg:w-24 xl:w-28 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
  //   width1: "text-red-500",
  // },
  {
    title: "WEF",
    key: "wef",
    key: "FormattedWEF",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Description",
    key: "Description",
    width: "md:w-24 lg:w-28 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];

const holidayMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "FormattedDate",
    width: "flex-1 xl:w-2 px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Day",
    key: "Day",
    width: "flex-1 px-1  xl:w-10 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Holiday",
    key: "Holiday",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:w-44 lg:w-96 xl:w-96 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const roomMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Photo",
    key: "Photo",
    width: "md:w-20  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomTypeName",
    width: "md:w-36 lg:w-36 xl:w-52 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Room ",
    key: "RoomName",
    width: "md:w-28 lg:w-28 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Description",
    key: "Description",
    width: "md:w-52 lg:w-52 xl:w-96 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "flex-1 px-1 py-2.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const enquiryHeaders = [
  {
    title: "S.No.",
    key: "SNo",
    width:
      "w-[6%] sm:w-[5%] md:w-[6%] lg:w-[3.5%] xl:w-[5%] 2xl:w-[3%] text-center whitespace-nowrap px-1 py-1.5 truncate",
  },
  {
    title: "Enquiry ID",
    key: "EnquiryNo",
    width:
      "w-[18%] sm:w-[15%] md:w-[19%] lg:w-[18%] xl:w-[14%] 2xl:w-[8%] px-2 py-1.5 truncate",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width:
      "w-[20%] sm:w-[18%] md:w-[14%] lg:w-[14%] xl:w-[12%] 2xl:w-[10%] whitespace-nowrap px-2 py-1.5 truncate",
  },
  {
    title: "Mobile",
    key: "MobileNumber",
    width:
      "w-[16%] sm:w-[14%] md:w-[14%] lg:w-[13%] xl:w-[10%] 2xl:w-[8%] px-2 py-1.5 truncate",
  },
  {
    title: "Booking Period",
    key: "BookingPeriod",
    width:
      "w-[22%] sm:w-[20%] md:w-[18%] lg:w-[16%] xl:w-[19%] 2xl:w-[12%] px-2 py-1.5 truncate",
  },
  {
    title: "Rooms",
    key: "RoomCountSummary",
    width:
      "w-[22%] sm:w-[20%] md:w-[18%] lg:w-[16%] xl:w-[14%] 2xl:w-[12%] px-2 py-1.5 truncate mr-auto",
  },
  {
    title: "Status",
    key: "action1",
    width:
      "w-[12%] sm:w-[10%] md:w-[9%] lg:w-[8%] xl:w-[7%] 2xl:w-[6%] px-2 py-1.5 truncate text-center ",
  },
  {
    title: "Action",
    key: "actionWithOutInactive",
    width:
      " w-[12%] sm:w-[10%] md:w-[9%] lg:w-[8%] xl:w-[7%] 2xl:w-[6%] px-2 py-1.5 truncate text-center ",
  },
];

const bookingEnquiryHeaders = [
  {
    title: "S.No.",
    key: "SNo",
    width:
      "w-[6%] sm:w-[5%] md:w-[6%] lg:w-[3.5%] xl:w-[5%] 2xl:w-[3%] text-center whitespace-nowrap px-1 py-1.5 truncate",
  },
  {
    title: "Enquiry ID",
    key: "EnquiryNo",
    width:
      "w-[18%] sm:w-[15%] md:w-[19%] lg:w-[18%] xl:w-[14%] 2xl:w-[8%] px-2 py-1.5 truncate",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width:
      "w-[20%] sm:w-[18%] md:w-[14%] lg:w-[14%] xl:w-[12%] 2xl:w-[10%] whitespace-nowrap px-2 py-1.5 truncate",
  },
  {
    title: "Mobile",
    key: "MobileNumber",
    width:
      "w-[16%] sm:w-[14%] md:w-[14%] lg:w-[13%] xl:w-[10%] 2xl:w-[8%] px-2 py-1.5 truncate",
  },
  {
    title: "Booking Period",
    key: "BookingPeriod",
    width:
      "w-[22%] sm:w-[20%] md:w-[18%] lg:w-[16%] xl:w-[19%] 2xl:w-[12%] px-2 py-1.5 truncate",
  },
  {
    title: "Rooms",
    key: "RoomCountSummary",
    width:
      "w-[22%] sm:w-[20%] md:w-[18%] lg:w-[16%] xl:w-[14%] 2xl:w-[12%] px-2 py-1.5 truncate mr-auto",
  },
  {
    title: "Status",
    key: "action1",
    width:
      "w-[12%] sm:w-[10%] md:w-[9%] lg:w-[8%] xl:w-[7%] 2xl:w-[6%] px-2 py-1.5 truncate text-center ",
  },
];

const enquiryLostHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry ID",
    key: "EnquiryNo",
    width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width: "md:w-24 lg:w-24 xl:w-44 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Mobile",
    key: "MobileNumber",
    width: "md:w-28 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking Period",
    key: "BookFrom",
    width: "md:w-28 lg:w-20 xl:w-24  2xl:w-96 px-1 py-1.5 flex justify-right",
    width1: "text-red-500",
  },
  {
    //title: "",
    key: "BookTo",
    width: "md:w-28 lg:w-20 xl:w-32 flex justify-left  2xl:w-96 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Rooms",
    key: "RoomCountSummary",
    width: "md:w-28 lg:w-24 xl:w-72 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Status",
    key: "actionlost",
    width: "px-2 py-1.5 flex justify-center md:w-16",
  },
  // {
  //   title: "Action",
  //   key: "action",
  //   width: "px-1.5 py-1.5 flex justify-center md:w-16",
  // },
];
const BookingDetailsHeaders = [
  {
    title: "S.No.",
    key: "SNo",
    width: "md:w-10 lg:w-10 xl:w-10 whitespace-pre-line 2xl:w-10 px-1 py-1.5 ",
  },
  {
    title: "Enquiry ID",
    key: "EnquiryNo",
    width: "md:w-24 lg:w-24 xl:w-32 whitespace-pre-line 2xl:w-24 px-1 py-1.5 ",
  },
  {
    title: "Booking ID",
    key: "BookingNo",
    width: "md:w-24 lg:w-24 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width: "md:w-24 lg:w-24 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "Mobile",
    key: "MobileNumber",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "Booking Period",
    key: "BookingPeriod",
    width: "md:w-24 lg:w-24 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "Rooms",
    key: "RoomCountSummary",
    width: "md:w-24 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "",
    key: "action3",
    width: "px-2 py-1.5 flex justify-center md:w-16",
  },
  {
    title: "Action",
    key: "actionWithOutInactive1",
    width: "px-2 py-1.5 flex justify-center md:w-16",
  },
];

const BookingDetailsHeaders1 = [
  {
    title: "S.No.",
    key: "SNo",
    width: "md:w-10 lg:w-10 xl:w-10 whitespace-pre-line 2xl:w-10 px-1 py-1.5 ",
  },
  {
    title: "Enquiry ID",
    key: "EnquiryNo",
    width: "md:w-24 lg:w-24 xl:w-32 whitespace-pre-line 2xl:w-24 px-1 py-1.5 ",
  },
  {
    title: "Booking ID",
    key: "BookingNo",
    width: "md:w-24 lg:w-24 xl:w-32 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width: "md:w-24 lg:w-24 xl:w-28 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "Mobile",
    key: "MobileNumber",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "Booking Period",
    key: "BookingPeriod",
    width: "md:w-24 lg:w-24 xl:w-44 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "Rooms",
    key: "RoomCountSummary",
    width: "md:w-24 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
  },
  {
    title: "RefundAmount",
    key: "RefundAmount",
    width: "px-2 py-1.5 flex justify-center md:w-16",
  },
  {
    title: "Status",
    key: "actionlost",
    width: "px-2 py-1.5 flex justify-center md:w-32",
  },
];

const reasonForLostHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-2 py-2 text-center",
  },
  {
    title: "Reason",
    key: "Reason",
    width: "md:w-56 2xl:w-64 px-3 py-2 text-left",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:flex-1 px-4 py-2 text-left",
    width1: "break-words whitespace-normal text-gray-600",
  },
  {
    title: "Action",
    key: "action",
    width: "md:w-20 px-2 py-2 flex justify-center",
  },
];

const PositionHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-2 py-2 text-center",
  },
  {
    title: "Position",
    key: "Position",
    width: "md:w-56 2xl:w-64 px-3 py-2 text-left",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:flex-1 px-4 py-2 text-left",
    width1: "break-words whitespace-normal text-gray-600",
  },
  {
    title: "Action",
    key: "action",
    width: "md:w-20 px-2 py-2 flex justify-center",
  },
];


const reasonForCancelHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Reason",
    key: "Reason",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];

const SourceTypeHeader = [  
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-2 py-2 text-center",
  },
  {
    title: "Source",
    key: "Source",    
    width: "md:w-56 2xl:w-64 px-3 py-2 text-left",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:flex-1 px-4 py-2 text-left",
    width1: "break-words whitespace-normal text-gray-600",
  },
  {
    title: "Action",
    key: "action",
    width: "md:w-20 px-2 py-2 flex justify-center",
  },
];
const ComplaintsListHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-2 py-2 text-center",
  },
  {
   
    title: "ComplaintsList",
    key: "ComplaintsList",
    width: "md:w-56 2xl:w-64 px-3 py-2 text-left",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:flex-1 px-4 py-2 text-left",
    width1: "break-words whitespace-normal text-gray-600",
  },
  {
    title: "Action",
    key: "action",
    width: "md:w-20 px-2 py-2 flex justify-center",
  },
];

const AmenitiesMasterHeader = [
  {
    title: "S.No.",
    key: "MstRoleId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Amenities Name",
    key: "Amenities",
    width: "md:w-60 lg:w-60 xl:w-52 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:w-96 lg:w-96 xl:w-[650px] 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  // {
  //   title: "Status",
  //   key: "Status",
  //   width: "md:w-48 lg:w-60 xl:w-58 2xl:m-auto px-1 py-1.5 ",
  //   width1: "text-red-500",
  // },
  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const LaundryIssueHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-12 xl:w-12 2xl:w-12  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Issue No",
    key: "LaundryIssueNo",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:w-32 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Issue Date",
    key: "FormatedDate",
    width: "md:w-24 lg:w-28 xl:w-28 2xl:w-28  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Laundry Company",
    key: "LaundryCompany",
    width: "md:w-72 lg:w-72 xl:w-[600px] 2xl:w-96  px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Quantity",
    key: "TotalQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-24  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Item Details",
    key: "LaundryIssueView",
    width: "md:w-24 lg:w-32 xl:w-32 2xl:w-32  px-1 py-1.5 2xl:mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "actionWithOutInactive",
    width: " px-1.5 py-1.5 flex justify-center  md:w-16",
  },
];
const LaundryReciptIssueHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 lg:w-12 xl:w-12 2xl:w-12  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Issue No",
    key: "LaundryIssueNo",
    width: "md:w-40 lg:w-40 xl:w-40 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Issue Date",
    key: "FormatedDate",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:w-28  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Laundry Company",
    key: "LaundryCompany",
    width: "md:w-60 lg:w-60 xl:w-60 2xl:w-96  px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Quantity",
    key: "TotalQuantity",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-24  px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Item Details",
    key: "LaundryIssueView",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:w-28  px-1 py-1.5 2xl:mr-auto",
    width1: "text-red-500",
  },
];
const LaundryIssueView = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "ItemType",
    width: "md:w-28 lg:w-60 xl:w-60 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "ItemCategory",
    width: "md:w-40 lg:w-52 xl:w-52 2xl:w-60  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "ItemName",
    width: "md:w-48 lg:w-48 xl:w-60 2xl:w-60  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Quantity",
    key: "Quantity",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Rate",
    key: "Rate",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
];

const LaundryViewReceipt = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "ItemType",
    width: "md:w-28 lg:w-60 xl:w-52 2xl:w-52 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "ItemCategory",
    width: "md:w-40 lg:w-52 xl:w-52 2xl:w-52  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "ItemName",
    width: "md:w-48 lg:w-48 xl:w-52 2xl:w-52  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Issued Qty.",
    key: "IssuedQuantity",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Received Qty.",
    key: "ReceivedQuantity",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-24  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Balance",
    key: "Balance",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
];

const LaundryReceiptView = [
  {
    title: "S.No.",
    key: "MstRoleId",
    width: "md:w-12 lg:w-12 xl:w-30 2xl:w-12  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Issue No",
    key: "issueNo",
    width: "md:w-28 lg:w-28 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "date",
    width: "md:w-28 lg:w-28 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "itemType",
    width: "md:w-28 lg:w-28 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "category",
    width: "md:w-40 lg:w-40 xl:w-44 2xl:w-30  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "name",
    width: "md:w-60 lg:w-60 xl:w-56 2xl:w-90  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-28  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Issued Quantity",
    key: "issuedQuantity",
    width: "md:w-20 lg:w-20 xl:w-48 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Received Quantity",
    key: "receivedQuantity",
    width: "md:w-20 lg:w-20 xl:w-48 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Balance",
    key: "balance",
    width: "md:w-32 lg:w-32 xl:w-48 2xl:w-30  px-1 py-1.5",
    width1: "text-red-500",
  },
];
const LaundryReceiptHeader = [
  {
    title: "S.No.",
    key: "MstRoleId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Receipt No",
    key: "ReceiptNo",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Received Date",
    key: "FormatedDate",
    width: "md:w-28 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Landry Name",
    key: "LaundryCompany",
    width: "md:w-60 xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Quantity",
    key: "TotalQuantity",
    width: "md:w-20 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Item Details",
    key: "LaundryIssueView",
    width: "md:w-20 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "actionWithOutInactive",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const StaffMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "EMP ID",
    key: "EmployeeID",
    width: "md:w-28 whitespace-normal break-words 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "FullName",
    width: "md:w-36 xl:w-64 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Position",
    key: "Position",
    width: "md:w-36 xl:w-64 whitespace-pre-line 2xl:flex-1 px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Gender",
    key: "Gender",
    width: "md:w-24 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Contact Number",
    key: "ContactNumber",
    width: "md:w-36 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const cancellationHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Room Name",
    key: "villaName",
    width: "md:w-24 lg:w-24 xl:w-30 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomType",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Location",
    key: "Location",
    width: "md:w-28 lg:w-24 xl:w-30 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Maximum Occupancy",
    key: "MaximumOccupancy",
    width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Area",
    key: "Area",
    width: "md:w-20 lg:w-40 xl:w-50 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Tariff",
    key: "Tariff",
    width: "md:w-20 lg:w-20 xl:w-30 2xl:w-96 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Aminities",
    key: "Aminities",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-96 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const shiftMasterHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Shift",
    key: "ShiftName",
    width: "md:w-24 lg:w-28 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "From Time",
    key: "FromTime",
    width: "md:w-48 lg:w-60 xl:w-24 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "To Time",
    key: "ToTime",
    width: "md:w-24 lg:w-60 xl:w-24 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:w-20 lg:w-72  xl:w-96 2xl:w-96 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];

const HouseKeepingHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "House Keeping No",
    key: "HouseKeepingNo",
    width: "md:w-20 lg:w-24 xl:w-36 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "Date1",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomTypeLabel",
    width: "md:w-20 lg:w-24 xl:w-28 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Room",
    key: "RoomName",
    width: "md:w-20 lg:w-24 xl:w-28 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Room Status",
    key: "RoomStatusLabel",
    width: "md:w-20 lg:w-24 xl:w-28 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Employee Name",
    key: "Employee",
    width: "md:w-20 lg:w-24 xl:w-40 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },

  {
    title: "In Time",
    key: "InTime",
    width: "md:w-20 lg:w-24 xl:w-20 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Out Time",
    key: "OutTime",
    width: "md:w-20 lg:w-24 xl:w-20 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const GradeHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Grade",
    key: "GradeName",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Gross salary Total",
    key: "GrossSalaryTotal",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Deduction Total",
    key: "DeductionsTotal",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Net Total",
    key: "NetTotal",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
// const  salaryMasterHeader = [
//   {
//     title: "S.No.",
//     key: "sno",
//     width: "md:w-12 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Grade",
//     key: "grade",
//     width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Gross salary Total",
//     key: "grossSalaryTotal",
//     width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
//     width1: "text-red-500",
//   },
//   {
//     title: "Deduction Total",
//     key: "deductionTotal",
//     width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
//     width1: "text-red-500",
//   },
//   {
//     title: "Net Total",
//     key: "netTotal",
//     width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
//     width1: "text-red-500",
//   },
//    {
//     title: "Action",
//     key: "action",
//     width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
//   },
// ];

const SalaryPayHeader = [
  {
    title: "Grade",
    key: "GradeName",
    width: "md:w-24 lg:w-24 xl:w-30 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Gross Salary Total",
    key: "GrossSalaryTotal",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Deduction Total",
    key: "DeductionsTotal",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Net Total",
    key: "NetTotal",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
];

const staffsalaryHeader = [
  {
    title: "S.no",
    key: "sno",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "EMP NO",
    key: "empno",
    width: "md:w-32 lg:w-36 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Name",
    key: "name",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Position",
    key: "position",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Gender",
    key: "DeductionsTotal",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Salary Grade",
    key: "salarygrade",
    width: "md:w-32 lg:w-36 xl:w-48 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Total Amount to be Paid",
    key: "totalamounttobepaid",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
];

const EnquirytobookingHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-16 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Room Name",
    key: "villaName",
    width: "md:w-24 lg:w-24 xl:w-48 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Room Tariff",
    key: "villaTariff",
    width: "md:w-24 lg:w-24 xl:w-48 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Enquiry Date",
    key: "enquirydate",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Booking Date",
    key: "bookingdate",
    width: "md:w-64 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5 ",
    width1: "text-red-500",
  },
];

const paymentHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Guest Name",
    key: "guestName",
    width: "md:w-48 lg:w-60 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "villa type",
    key: "villaType",
    width: "md:w-48 lg:w-60 xl:w-28 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Check In Date",
    key: "checkInDate",
    width: "md:w-48 lg:w-60 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Check Out Date",
    key: "checkOutDate",
    width: "md:w-48 lg:w-52 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Advance Amount",
    key: "advanceAmount",
    width: "md:w-48 lg:w-60 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Payment Method",
    key: "paymentMethod",
    width: "md:w-48 lg:w-60 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Total Amount",
    key: "totalAmount",
    width: "md:w-48 lg:w-60 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
    width1: "text-red-500",
  },
];
const openingStockHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "ItemType",
    width: "md:w-48 lg:w-52 xl:w-24 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Items Category",
    key: "ItemCategory",
    width: "md:w-48 lg:w-52 xl:w-32 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "ItemName",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-48 lg:w-52 xl:w-16 2xl:m-auto px-2 py-1.5 mr-auto",
  },
  {
    title: "Action",
    key: "action10",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const issueHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Issue No",
    key: "IssueNo",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Issue Date",
    key: "FormattedDate",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Issue To",
    key: "RoomType",
    width: "md:w-48 lg:w-52 xl:w-72 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Room",
    key: "RoomName",
    width: "md:w-48 lg:w-52 xl:w-72 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Items",
    key: "LaundryIssueView",
    width:
      "md:w-16 lg:w-16 xl:w-16 whitespace-pre-line 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "actionWithOutInactiveAndDelete",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const damagesHeader = [
  {
    title: "S.No",
    key: "TxnDamageId",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Damages No",
    key: "DamageNo",
    width: "md:w-48 lg:w-52 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-48 lg:w-52 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomTypeName",
    width: "md:w-48 lg:w-52 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Room",
    key: "RoomName",
    width: "md:w-48 lg:w-52 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Reported By",
    key: "StaffName",
    width: "md:w-48 lg:w-52 xl:w-60 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "actionWithOutInactiveAndDelete",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const consumptionHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Consumption No",
    key: "ConsumptionNo",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:w-80 lg:w-96 xl:w-[650px] 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Items",
    key: "ConsumptionView",
    width: "md:w-16 lg:w-16 xl:w-16 2xl:m-auto px-1 py-1.5 mr-auto",
  },
  {
    title: "Action",
    key: "actionWithOutInactiveAndDelete",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const ConsumptionViewHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-12 px-1 py-1.5 ",
  },
  {
    title: "Consumption No.",
    key: "ConsumptionNo",
    width:
      "md:w-24 lg:w-24 xl:w-24 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Date",
    key: "FormattedConsumptionDate",
    width:
      "md:w-20 lg:w-20 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Category",
    key: "CommodityCategory_en",
    width: "md:w-20 lg:w-24 xl:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5",
  },
  {
    title: "Name",
    key: "CommodityName_en",
    width: "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5",
  },
  {
    title: "Brand",
    key: "Brand_en",
    width:
      "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line  px-1 py-1.5 ",
  },
  {
    title: "Demo.",
    key: "Demonstration",
    width:
      "md:w-12 lg:w-12 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Damaged/Adjustments",
    key: "DamagedAdjustments",
    width:
      "md:w-12 lg:w-12 xl:w-24 2xl:flex-1  whitespace-pre-line break-words px-1 py-1.5 ",
  },
  {
    title: "Exp.",
    key: "Expired",
    width:
      "md:w-12 lg:w-12 xl:w-20 2xl:flex-1 whitespace-pre-line px-1 py-1.5 mr-auto",
  },
  // {
  //   title: "Assoc. Clinic",
  //   key: "GivenToAssociatedClinics",
  //   width:
  //     "md:w-20 lg:w-20 xl:w-32 2xl:flex-1 whitespace-pre-line px-1 py-1.5 mr-auto",
  // },
  {
    title: "Total",
    key: "Total",
    width: "md:w-14 px-1 py-1.5 ",
  },
];

const ComplaintsAndIssuesHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-16 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Complaint Date",
    key: "complaintDate",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Guest Name",
    key: "guestName",
    width: "md:w-24 lg:w-24 xl:w-48 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "villaType",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Name",
    key: "villaName",
    width: "md:w-64 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Complaint",
    key: "complaint",
    width: "md:w-64 lg:w-36 xl:w-52 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "status",
    width: "md:w-64 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Resolve Date",
    key: "resolveDate",
    width: "md:w-64 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
];
const RevenueExpenseHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-16 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Total Revenue",
    key: "totalRevenue",
    width: "md:w-24 lg:w-24 xl:w-48 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Total Expense",
    key: "totalExpense",
    width: "md:w-32 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Net Profit/Loss",
    key: "netProfitLoss",
    width: "md:w-64 lg:w-36 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "No of Days",
    key: "noOfDays",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
];
const RevenueExpenseDetailsHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-16 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "date",
    width: "md:w-24 lg:w-24 xl:w-32 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "villaType",
    width: "md:w-32 lg:w-36 xl:w-52 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Name",
    key: "villaName",
    width: "md:w-64 lg:w-36 xl:w-52 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Revenue",
    key: "revenue",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Expense",
    key: "expense",
    width: "md:w-24 lg:w-24 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
];

const SalaryMappingHeader = [
  {
    title: "S.No.",
    key: "MstRoleId",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "FormattedDate",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Staff Name",
    key: "StaffName1",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Salary Grade",
    key: "Grade",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const ReceiptsHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-12  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Receipt No.",
    key: "ReceiptNo",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
  },
  {
    title: "Date",
    key: "FormattedDate",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:flex-1 px-1 pr-6 py-1.5 ",
  },

  {
    title: "Received From",
    key: "ReceivedFrom",
    width:
      "md:w-44 lg:w-44 xl:w-80 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Received By",
    key: "ReceivedBy",
    width: "md:w-44 lg:w-44 xl:w-80 2xl:flex-1 2xl:flex-1 px-1 py-1.5",
  },
  {
    title: "Items",
    key: "LaundryIssueView",
    width:
      "md:w-16 lg:w-16 xl:w-16 whitespace-pre-line 2xl:flex-1 px-1 py-1.5 mr-auto ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "actionWithOutInactiveAndDelete",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const bookedHeader = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Guest Name",
    key: "Name",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "GuestMobile",
    width: "md:w-28 lg:w-24 xl:w-36 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "From-Date",
    key: "FromDate",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "To-Date",
    key: "ToDate",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "LocationName_en",
    width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "VillaName",
    key: "Villaname",
    width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "action2",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
// const checkOutHeader = [
//   {
//     title: "S.No.",
//     width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Guest Name",
//     key: "GuestName",
//     width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Mobile",
//     key: "MobileNumber",
//     width: "md:w-28 lg:w-24 xl:w-36 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "From-Date",
//     key: "BookFrom",
//     width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "To-Date",
//     key: "BookTo",
//     width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "City",
//     key: "City",
//     width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Room Type",
//     key: "RoomTypes",
//     width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Action",
//     key: "action4",
//     width: "px-1.5 py-1.5 flex justify-center md:w-16",
//   },
// ];

const checkOutHeader = [
  {
    title: "S.No.",
    width: "w-[5%] px-2 py-2 text-center",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width: "w-[18%] px-2 py-2",
  },
  {
    title: "Mobile",
    key: "MobileNumber",
    width: "w-[15%] px-2 py-2",
  },
  {
    title: "From-Date",
    key: "BookFrom",
    width: "w-[12%] px-2 py-2",
  },
  {
    title: "To-Date",
    key: "BookTo",
    width: "w-[12%] px-2 py-2",
  },
  {
    title: "City",
    key: "City",
    width: "w-[15%] px-2 py-2 truncate",
  },
  {
    title: "Room Type",
    key: "RoomTypes",
    width: "w-[15%] px-2 py-2 truncate",
  },
  {
    title: "Action",
    key: "action4",
    width: "w-[8%] px-2 py-2 text-center",
  },
];
// const checkOutHeader1 = [
//   {
//     title: "S.No.",
//     width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Guest Name",
//     key: "GuestName",
//     width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Mobile",
//     key: "MobileNumber",
//     width: "md:w-28 lg:w-24 xl:w-36 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "From-Date",
//     key: "BookFrom",
//     width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "To-Date",
//     key: "BookTo",
//     width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "City",
//     key: "City",
//     width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Room Type",
//     key: "RoomTypes",
//     width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Action",
//     key: "actionWithOutInactive",
//     width: "px-1.5 py-1.5 flex justify-center md:w-16",
//   },
// ];

// const checkOutHeader1 = [
//   {
//     title: "S.No.",
//     width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Guest Name",
//     key: "GuestName",
//     width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Mobile",
//     key: "MobileNumber",
//     width: "md:w-28 lg:w-24 xl:w-36 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "From-Date",
//     key: "BookFrom",
//     width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "To-Date",
//     key: "BookTo",
//     width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "City",
//     key: "City",
//     width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Room Type",
//     key: "RoomTypes",
//     width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
//     width1: "text-red-500",
//   },
//   {
//     title: "Action",
//     key: "actionWithOutInactive",
//     width: "px-1.5 py-1.5 flex justify-center md:w-16",
//   },
// ];

// const checkOutHeader1 = [
//   {
//     title: "S.No.",
//     width: "w-[5%] px-2 py-2 text-center",
//   },
//   {
//     title: "Guest Name",
//     key: "GuestName",
//     width: "w-[18%] px-2 py-2",
//   },
//   {
//     title: "Mobile",
//     key: "MobileNumber",
//     width: "w-[15%] px-2 py-2",
//   },
//   {
//     title: "From-Date",
//     key: "BookFrom",
//     width: "w-[12%] px-2 py-2",
//   },
//   {
//     title: "To-Date",
//     key: "BookTo",
//     width: "w-[12%] px-2 py-2",
//   },
//   {
//     title: "City",
//     key: "City",
//     width: "w-[10%] px-2 py-2 truncate",
//   },
//   {
//     title: "Room Type",
//     key: "RoomTypes",
//     width: "w-[20%] px-2 py-2 truncate",
//   },
//   {
//     title: "Action",
//     key: "action4",
//     width: "w-[8%] px-2 py-2 text-center",
//   },
// ];

const checkOutHeader1 = [
  {
    title: "S.No.",
    width: "w-[5%] px-2 py-2 text-center",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width: "w-[18%] px-2 py-2",
  },
  {
    title: "Mobile",
    key: "MobileNumber",
    width: "w-[15%] px-2 py-2",
  },
  {
    title: "From-Date",
    key: "BookFrom",
    width: "w-[12%] px-2 py-2",
  },
  {
    title: "To-Date",
    key: "BookTo",
    width: "w-[12%] px-2 py-2",
  },
  {
    title: "City",
    key: "City",
    width: "w-[10%] px-2 py-2 truncate",
  },
  {
    title: "Room Type",
    key: "RoomTypes",
    width: "w-[20%] px-2 py-2 truncate",
  },
  {
    title: "Action",
    key: "actionWithOutInactive",
    width: "w-[5%] px-2 py-2 text-center",
  },
];
const checkInHeader = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "MobileNumber",
    width: "md:w-24 lg:w-24 xl:w-24 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "From-Date",
    key: "BookFrom",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "To-Date",
    key: "BookTo",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "City",
    width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomTypes",
    width:
      "md:w-28 lg:w-24 xl:w-60 2xl:w-96 px-1 py-1.5 truncate overflow-hidden text-ellipsis",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action5",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const checkInHeader1 = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "MobileNumber",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "From-Date",
    key: "BookFrom",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500", ///////////////////////////////////////////////////////////////
  },
  {
    title: "To-Date",
    key: "BookTo",
    width: "md:w-24 lg:w-24 xl:w-24 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "City",
    width: "md:w-28 lg:w-24 xl:w-40 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomTypes",
    width:
      "md:w-28 lg:w-24 xl:w-40 truncate overflow-hidden text-ellipsis 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "actionWithOutInactive",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const maintenanceHeader = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "FormattedMaintenanceDate",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "RoomType",
    key: "RoomType",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room",
    key: "RoomName",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "FixedAsset",
    key: "ItemCategory",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "IssueType",
    key: "IssuesType",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Amount",
    key: "Amount",
    width: "md:w-32 lg:w-36 xl:w-56 whitespace-pre-line 2xl:w-96 px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action10",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
    width1: "text-red-500",
  },
];
const LaundryCompanyHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  // {
  //   title: "Logo",
  //   key: "LaundryLogo",
  //   width: "md:w-16 lg:w-16 xl:w-24 2xl:m-auto px-1 py-1.5 ",
  //   width1: "text-red-500",
  // },
  {
    title: "Laundry Id",
    key: "LaundryCompanyId",
    width: "md:w-32 lg:w-32 xl:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Company Name",
    key: "LaundryCompany",
    width: "md:w-32 lg:w-32 xl:w-52 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "City",
    width: "md:w-28 lg:w-28 xl:w-52 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "MobileNumber",
    width: "md:w-28 lg:w-28 xl:w-28 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "EmailId",
    width: "md:w-28 lg:w-28 xl:w-52 2xl:flex-1 px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const laundryHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Issue No",
    key: "IssueNo",
    width: "md:w-48 lg:w-40 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Issue Date",
    key: "IssueDate",
    width: "md:w-48 lg:w-60 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Laundry Name",
    key: "LaundryName",
    width: "md:w-55 lg:w-60 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Quantity",
    key: "TotalQuantity",
    width: "md:w-30 lg:w-52 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "md:w-50 lg:w-60 xl:w-52 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
];

const SalaryPaidHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "SalaryDate",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Staff Name",
    key: "StaffName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Salary Grade",
    key: "Grade",
    width: "md:w-20 2xl:flex-1 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Total",
    key: "TotalAmounttobePaid",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const PayrollHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "SalaryDate",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Month",
    key: "StaffName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Total Amount",
    key: "TotalAmounttobePaid",
    width: "md:w-64 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "status", // fixed key
    width: "md:w-64 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];

const AttendanceHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Staff",
    key: "StaffName",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Status",
    key: "Status",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "In time",
    key: "MInTime",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Out time",
    key: "AOutTime",
    width: "md:w-96 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];

const mappingroomtype = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Photo",
    key: "Photo",
    width: "md:w-44 lg:w-44 xl:w-20 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomType",
    width: "md:w-48 lg:w-60 xl:w-32 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "No of Rooms",
    key: "NoOfRooms",
    width: "md:w-48 lg:w-60 xl:w-16 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },

  {
    title: "Size in Sq.ft",
    key: "Size",
    width: "md:w-96 lg:w-96 xl:w-20 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Max. Occupancy",
    key: "MaxOccupancy",
    width: "md:w-96 lg:w-96 xl:w-24 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:w-44 lg:w-44 xl:w-96 2xl:m-auto px-1 py-1.5",
  },
  {
    title: "View",
    key: "MapView",
    width: "px-1.5 md:w-24 py-1.5 flex justify-center  ",
  },
  {
    title: "Action",
    key: "Map",
    width: "px-1.5 md:w-24 py-1.5 flex justify-center",
  },
];

// const ItemCategoryHeader =[  {

//     title: "S.No.",
//     key: "sno",
//     width: "md:w-12 px-1 py-1.5",
//   },
//   {
//     title: "Item Category",
//     key: "itemscategory",
//     width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5",
//   },
//   {
//     title: "Description",
//     key: "description",
//     width: "md:w-80 px-1 py-1.5",
//   },
// {
//   title: "Action",
//   key: "action",
//   width: "px-1.5 py-1.5 flex justify-center md:w-96 ",
// },

// ]
const mappingroomtypewithtariff1 = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-16 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Room Type",
    key: "RoomType",
    width: "md:w-44 lg:w-44 xl:w-40 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Base Tariff",
    key: "Rooms",
    width: "md:w-44 lg:w-44 xl:w-40 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Holiday Tariff",
    key: "Size",
    width: "md:w-44 lg:w-44 xl:w-32 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Special Tariff",
    key: "Occupancy",
    width: "md:w-44 lg:w-44 xl:w-44 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "From Date",
    key: "date",
    width: "md:w-44 lg:w-44 xl:w-44 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
];

const SpaceTypeHeader = [
  {
    title: "S.No.",
    key: "MstSpaceTypeId",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Space",
    key: "Space",
    width: "md:w-48 lg:w-60 xl:w-32 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:w-48 lg:w-60 xl:w-[650px]  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-32 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const ItemCategoryHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item type",
    key: "ItemType",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Item category",
    key: "ItemCategory",
    width: "md:w-48 lg:w-60 xl:w-60 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "Description",
    width: "md:w-48 lg:w-60 xl:w-96 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: "px-1.5 py-1.5 flex justify-center md:w-16 ",
  },
];
const mappingroomtypewithSpaces = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-16 px-1 py-1.5 flex items-center",
    width1: "text-red-500",
  },

  {
    title: "Space",
    key: "Space",
    width: "md:w-44   px-1 py-1.5 flex items-center",
    width1: "text-red-500",
  },
  {
    title: "Space Count",
    key: "SpaceCount",
    width: "md:w-28 px-1 py-1.5 flex items-center ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "SpaceDate",
    width: "md:w-32 px-1 py-1.5 flex items-center ",
    width1: "text-red-500",
  },
];
const mappingroomtypewithamenities = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-16 px-1 py-1.5 flex items-center",
    width1: "text-red-500",
  },

  {
    title: "Amenities",
    key: "Amenities",
    width: "md:w-44   px-1 py-1.5 flex items-center",
    width1: "text-red-500",
  },
  {
    title: "Amenities Count",
    key: "AmenitiesCount",
    width: "md:w-32 px-1 py-1.5 flex items-center  ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "AmenitiesDate",
    width: "md:w-32 px-1 py-1.5 flex items-center ",
    width1: "text-red-500",
  },
];
const clientsHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Property Name",
    key: "PropertyName",
    width: "md:w-32 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Property Type",
    key: "PropertyTypes",
    width: "md:w-32  px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },

  {
    title: "No. Of Users",
    key: "NoofUsersRequired",
    width: "md:w-20 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  // {
  //   title: "Deadline",
  //   key: "deadline",
  //   width: "md:w-28  2xl:m-auto px-1 py-1.5 ",
  //   width1: "text-red-500",
  // },
  {
    title: "Email",
    key: "Email",
    width: "md:w-36 xl:w-60 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "ContactNumber",
    width: "md:w-24 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  //  {
  //   title: "Address",
  //   key: "Address",
  //   width: "md:w-24 xl:w-40 px-1 py-1.5 whitespace-pre-line mr-auto",
  //   width1: "text-red-500",
  // },
  // {
  //   title: "Designation",
  //   key: "designation",
  //   width: "md:w-20 2xl:m-auto px-1 py-1.5",
  //   width1: "text-red-500",
  // },
  {
    title: "Invoices",
    key: "Invoices",
    width: "md:w-20 2xl:m-auto px-1 py-1.5 whitespace-pre-line mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "UploadAction",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
    width1: "text-red-500",
  },
];
const invoicesHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Invoice Type",
    key: "InvoiceType",
    width: "md:w-32 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Invoice No",
    key: "InvoiceNo",
    width: "md:w-32  px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },

  {
    title: "Invoice Date",
    key: "InvoiceDate",
    width: "md:w-32 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  // {
  //   title: "Deadline",
  //   key: "deadline",
  //   width: "md:w-28  2xl:m-auto px-1 py-1.5 ",
  //   width1: "text-red-500",
  // },
  {
    title: "Invoice Amount",
    key: "InvoiceAmount",
    width: "md:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "Status",
    width: "md:w-24 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
];
const popupUserHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "User Name",
    key: "UserName",
    width: "md:w-40 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Role",
    key: "RoleName",
    width: "md:w-32 xl:w-32 2xl:m-auto px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
  {
    title: "Mobile",
    key: "UserMobile",
    width: "md:w-32  px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },

  {
    title: "Email",
    key: "UserEmail",
    width: "md:w-96 px-1 py-1.5 whitespace-pre-line",
    width1: "text-red-500",
  },
];

const PaymentInfoHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 2xl:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Partner Name",
    key: "partnername",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Payment Date",
    key: "paymentdate",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Bank",
    key: "bank",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Amount",
    key: "amount",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Reference No",
    key: "referenceno",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Payment Method",
    key: "paymentmethod",
    width: "md:w-48 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const DamagesHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "date",
    width: "md:w-48 lg:w-60 xl:w-28 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room / Area",
    key: "location",
    width: "md:w-48 lg:w-60 xl:w-30 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item",
    key: "item",
    width: "md:w-48 lg:w-52 xl:w-28 2xl:m-auto px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Cost",
    key: "cost",
    width: "md:w-48 lg:w-52 xl:w-20 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Reported By",
    key: "reportedBy",
    width: "md:w-48 lg:w-52 xl:w-28 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Description",
    key: "description",
    width: "md:w-48 lg:w-52 xl:w-64 2xl:m-auto px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const stateMasterHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "State",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "State Code",
    key: "StateCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const CountryMasterHeader = [
  {
    title: "S.No.",
    key: "Sno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  // {
  //   title: "State",
  //   key: "StateName_en",
  //   width: "flex-1 px-1 py-1.5 m-auto",
  //   width1: "text-red-500",
  // },
  {
    title: "Country Code",
    key: "CountryCode",
    width: "flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];
const locationMasterHeader = [
  {
    title: "S.No.",
    key: "LocationSno",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName_en",
    width: "md:w-52 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "StateName_en",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "LocationName_en",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "City Code",
    key: "LocationCode",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];
const foodsAndBeveragesHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Photo",
    key: "FoodImage",
    width: "md:w-20  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Food Type",
    key: "FoodType",
    width: "md:w-32 px-1 py-1.5 ",
    width1: "text-green-600", // You can adjust class based on Veg/Non-Veg if needed
  },
  {
    title: "Sub Food Type",
    key: "SubFoodType",
    width: "md:w-48 lg:w-60 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Food Name",
    key: "FoodName",
    width: "md:w-48 lg:w-60 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Cost",
    key: "Rate",
    width: "md:w-48 lg:w-60 xl:w-28 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const PurchaseHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-30 2xl:w-12  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "ItemType",
    width: "md:w-28 lg:w-28 xl:w-44 2xl:flex-1 px-1 py-1.5 ",
  },
  {
    title: "Category",
    key: "ItemCategory",
    width: "md:w-28 lg:w-28 xl:w-52 2xl:flex-1 px-1 py-1.5 ",
  },

  {
    title: "U.O.M",
    key: "UOM",
    width:
      "md:w-32 lg:w-32 xl:w-52 whitespace-pre-line 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Quantity",
    key: "Quantity",
    width:
      "md:w-32 lg:w-32 xl:w-52 2xl:flex-1 whitespace-pre-line px-1 py-1.5 ",
  },
  {
    title: "Amount",
    key: "Amount",
    width: "md:w-28 lg:w-28 xl:w-40 2xl:flex-1 2xl:flex-1 px-1 py-1.5  mr-auto",
  },
  {
    title: "Action",
    key: "actionWithOutInactiveAndDelete",
    width: "px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

const ItemPopupHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-30 2xl:w-12  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "itemType",
    width: "md:w-24 lg:w-30 xl:w-60 2xl:w-24 px-3 py-1.5 ",
  },
  {
    title: "Category",
    key: "category",
    width: "md:w-24 lg:w-24 xl:w-60 2xl:w-24 px-3 py-1.5  ",
  },

  {
    title: "Name",
    key: "name",
    width: "md:w-32 lg:w-32 xl:w-52  2xl:flex-1 px-1 py-1.5 ",
    width: "md:w-24 lg:w-24 xl:w-60  2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Quantity",
    key: "quantity",
    width: "md:w-24 lg:w-24 xl:w-30 2xl:w-24 2xl:flex-1 px-1 py-1.5",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-16 lg:w-16 xl:w-30 2xl:w-16 px-1 py-1.5 ",
  },
  {
    title: "Rate",
    key: "rate",
    width: "md:w-24 lg:w-24 xl:w-30 2xl:w-24 px-3 py-1.5 ",
  },
  // {
  //   title: "Action",
  //   key: "action",
  //   width: " px-1.5 py-1.5 flex justify-center md:w-16",
  // },
];

const IssueItemPopupHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-30 2xl:w-12  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "itemType",
    width: "md:w-24 lg:w-30 xl:w-60 2xl:w-24 px-3 py-1.5 ",
  },
  {
    title: "Category",
    key: "category",
    width: "md:w-24 lg:w-24 xl:w-60 2xl:w-24 px-3 py-1.5  ",
  },

  {
    title: "Name",
    key: "name",
    width: "md:w-24 lg:w-24 xl:w-60  2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Quantity",
    key: "quantity",
    width: "md:w-24 lg:w-24 xl:w-30 2xl:w-24 2xl:flex-1 px-1 py-1.5",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-16 lg:w-16 xl:w-30 2xl:w-16 px-1 py-1.5 ",
  },
  {
    title: "Rate",
    key: "rate",
    width: "md:w-24 lg:w-24 xl:w-30 2xl:w-24 px-3 py-1.5 ",
  },
];

const DamagespopupHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-30 2xl:w-12  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "itemType",
    width: "md:w-10 lg:w-30 xl:w-40 2xl:w-24 px-3 py-1.5 ",
  },
  {
    title: "Category",
    key: "category",
    width: "md:w-10 lg:w-30 xl:w-40 2xl:w-24 px-3 py-1.5  ",
  },

  {
    title: "Name",
    key: "name",
    width: "md:w-24 lg:w-30 xl:w-50 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  // {
  //   title: "Rate",
  //   key: "rate",
  //   width:
  //     "md:w-24 lg:w-24 xl:w-50 2xl:w-24 px-3 py-1.5 ",
  // },
  {
    title: "Quantity",
    key: "quantity",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-24 2xl:flex-1 px-1 py-1.5",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-16 lg:w-16 xl:w-40 2xl:w-16 px-1 py-1.5 ",
  },
  {
    title: "Value",
    key: "Value",
    width: "md:w-24 lg:w-24 xl:w-50 2xl:w-24 2xl:flex-1 px-1 py-1.5",
  },
];
const CityHeader = [
  {
    title: "S.No.",
    key: "MstCityId",
    width: "md:w-14 2xl:w-12 px-1 py-1.5  m-auto",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName",
    width: "md:w-52 2xl:flex-1 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "State",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "City",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "City Code",
    key: "CityCode",
    width: "md:w-60 2xl:flex-1 px-1 py-1.5 m-auto",
    width1: "text-red-500",
  },
  {
    title: "Action",
    key: "action",
    width: " px-1 py-1.5 m-auto",
  },
];

const ConsumptionHeaders = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-30 2xl:w-12  px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "itemType",
    width: "md:w-10 lg:w-30 xl:w-40 2xl:w-24 px-3 py-1.5 ",
  },
  {
    title: "Item Category",
    key: "itemCategory",
    width: "md:w-10 lg:w-30 xl:w-40 2xl:w-24 px-3 py-1.5  ",
  },

  {
    title: "Item",
    key: "item",
    width: "md:w-24 lg:w-30 xl:w-50 2xl:w-24 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Quantity",
    key: "quantity",
    width: "md:w-24 lg:w-24 xl:w-40 2xl:w-24 2xl:flex-1 px-1 py-1.5",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-16 lg:w-16 xl:w-40 2xl:w-16 px-1 py-1.5 ",
  },
];

const ConsumptionView = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "ItemType",
    width: "md:w-28 lg:w-60 xl:w-60 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "ItemCategory",
    width: "md:w-40 lg:w-52 xl:w-52 2xl:w-60  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "ItemName",
    width: "md:w-48 lg:w-48 xl:w-60 2xl:w-60  px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Quantity",
    key: "Quantity",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
];

const ReceiptView = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "ItemType",
    width: "md:w-28 lg:w-60 xl:w-60 whitespace-pre-line 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "ItemCategory",
    width: "md:w-28 lg:w-52 xl:w-52 2xl:w-60 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "ItemName",
    width: "md:w-28 lg:w-48 xl:w-60 2xl:w-60 whitespace-pre-line px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Quantity",
    key: "Quantity",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-16 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Rate",
    key: "Rate",
    width: "md:w-16 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
];
const enquiryReportHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry ID",
    key: "EnquiryID",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry Date",
    key: "EnquiryDate",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry Type",
    key: "EnquiryType",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry Person Name",
    key: "EnquiryPersonName",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "MobileNumber",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Contact number of Guest",
    key: "ContactNumberOfGuest",
    width: "md:w-36 lg:w-44 xl:w-48 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Source Type",
    key: "ReferralSource",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5 flex justify-right",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomTypes",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Basic Tariff",
    key: "BasicTariff",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Special Tariff",
    key: "SpecialTariff",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "No. of required rooms",
    key: "NoOfRequiredRooms",
    width: "md:w-36 lg:w-40 xl:w-40 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "No. of adults",
    key: "NoOfAdults",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "No. of children",
    key: "NoOfChildren",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Amount",
    key: "TotalAmount",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Status",
    key: "EnquiryStatus",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Lost/cancel Reason",
    key: "LostOrCancelReason",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
];

const bookingReportHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry No.",
    key: "EnquiryNo",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry Date",
    key: "EnquiryDate",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking No.",
    key: "BookingNo",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking Date",
    key: "BookingDate",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry Type",
    key: "EnquiryType",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking From",
    key: "BookingFrom",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Booking To",
    key: "BookingTo",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking Type",
    key: "EnquiryType",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "NO. Of days",
    key: "NoOfDays",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },

  {
    title: "Enquiry Person Name",
    key: "EnquiryPersonName",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "MobileNumber",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "State",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },

  {
    title: "City",
    key: "City",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Address",
    key: "Address",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Booking Person Name",
    key: "BookingPersonName",
    width: "md:w-36 lg:w-36 xl:w-44  2xl:w-48 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "BookingPersonMobileNumber",
    width: "md:w-36 lg:w-32 xl:w-32  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "BookingPersonCountry",
    width: "md:w-28 lg:w-28 xl:w-28  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "BookingPersonState",
    width: "md:w-28 lg:w-28 xl:w-32  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "BookingPersonCity",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Person Address",
    key: "BookingPersonAddress",
    width: "md:w-44 lg:w-44 xl:w-44  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Source Type",
    key: "ReferralSource",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Source",
    key: "Source",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "ID-Proof",
    key: "IdProof",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "ID-Number",
    key: "IdNumber",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomTypes",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Names",
    key: "RoomNames",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Basic Tariff",
    key: "BookingBasicTariff",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Special Tariff",
    key: "BookingSpecialTariff",
    width: "md:w-36 lg:w-36 xl:w-36 whitespace-pre-line justify-left  2xl:w-36 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking No. Of Required Rooms",
    key: "BookingNoOfRequiredRooms",
    width: "md:w-36 lg:w-36 xl:w-36 whitespace-pre-line justify-left  2xl:w-36 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking No. Of Adults",
    key: "BookingNoOfAdults",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking No. Of Children",
    key: "BookingNoOfChildren",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Amount",
    key: "BookingAmount",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Received Amount",
    key: "BookingReceivedAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Balance Amount",
    key: "BookingBalanceAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Payment Type",
    key: "BookingPaymentType",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Payment Reference Number",
    key: "BookingPaymentReferenceNumber",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Status",
    key: "BookingStatus",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Cancel Reason",
    key: "CancelReason",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Refund Amount",
    key: "RefundAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Cancel Payment Type",
    key: "CancelPaymentType",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Cancel Reference Number",
    key: "CancelReferenceNumber",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Revenue",
    key: "Revenue",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
];
const checkInReportHeaders = [
   {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry No.",
    key: "EnquiryNo",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry Date",
    key: "EnquiryDate",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking No.",
    key: "BookingNo",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking Date",
    key: "BookingDate",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry Type",
    key: "EnquiryType",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking From",
    key: "BookingFrom",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Booking To",
    key: "BookingTo",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking Type",
    key: "EnquiryType",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "NO. Of days",
    key: "NoOfDays",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },

  {
    title: "Enquiry Person Name",
    key: "EnquiryPersonName",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "MobileNumber",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "State",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },

  {
    title: "City",
    key: "City",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Address",
    key: "Address",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Booking Person Name",
    key: "BookingPersonName",
    width: "md:w-36 lg:w-36 xl:w-44  2xl:w-48 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "BookingPersonMobileNumber",
    width: "md:w-36 lg:w-32 xl:w-32  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "BookingPersonCountry",
    width: "md:w-28 lg:w-28 xl:w-28  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "BookingPersonState",
    width: "md:w-28 lg:w-28 xl:w-32  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "BookingPersonCity",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Person Address",
    key: "BookingPersonAddress",
    width: "md:w-44 lg:w-44 xl:w-44  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Source Type",
    key: "ReferralSource",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Source",
    key: "Source",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "ID-Proof",
    key: "IdProof",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "ID-Number",
    key: "IdNumber",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomTypes",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Names",
    key: "RoomNames",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Basic Tariff",
    key: "BookingBasicTariff",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Special Tariff",
    key: "BookingSpecialTariff",
    width: "md:w-36 lg:w-36 xl:w-36 whitespace-pre-line justify-left  2xl:w-36 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking No. Of Required Rooms",
    key: "BookingNoOfRequiredRooms",
    width: "md:w-36 lg:w-36 xl:w-36 whitespace-pre-line justify-left  2xl:w-36 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking No. Of Adults",
    key: "BookingNoOfAdults",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking No. Of Children",
    key: "BookingNoOfChildren",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Amount",
    key: "BookingAmount",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Received Amount",
    key: "BookingReceivedAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Balance Amount",
    key: "BookingBalanceAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Payment Type",
    key: "BookingPaymentType",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Payment Reference Number",
    key: "BookingPaymentReferenceNumber",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Status",
    key: "BookingStatus",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "CheckIn Date",
    key: "CheckInDate",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Gender",
    key: "Gender",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Age",
    key: "Age",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Relationship",
    key: "Relationship",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "ID Proof Type",
    key: "IdProof",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "ID Proof Number",
    key: "IDProofNumber",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Photo",
    key: "Photo",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "CheckIn Additional Adults",
    key: "CheckInAdditionalAdults",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Additional Children",
    key: "CheckInAdditionalChildren",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Received Amount",
    key: "CheckInReceivedAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Balance Amount",
    key: "CheckInBalanceAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Payment Type",
    key: "CheckInPaymentType",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Payment Reference Number",
    key: "CheckInPaymentReferenceNumber",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
];
const checkOutReportHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry No.",
    key: "EnquiryNo",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry Date",
    key: "EnquiryDate",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking No.",
    key: "BookingNo",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking Date",
    key: "BookingDate",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Enquiry Type",
    key: "EnquiryType",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking From",
    key: "BookingFrom",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Booking To",
    key: "BookingTo",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Booking Type",
    key: "EnquiryType",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "NO. Of days",
    key: "NoOfDays",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },

  {
    title: "Enquiry Person Name",
    key: "EnquiryPersonName",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "MobileNumber",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "CountryName",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "State",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },

  {
    title: "City",
    key: "City",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Address",
    key: "Address",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Booking Person Name",
    key: "BookingPersonName",
    width: "md:w-36 lg:w-36 xl:w-44  2xl:w-48 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Mobile Number",
    key: "BookingPersonMobileNumber",
    width: "md:w-36 lg:w-32 xl:w-32  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Country",
    key: "BookingPersonCountry",
    width: "md:w-28 lg:w-28 xl:w-28  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "State",
    key: "BookingPersonState",
    width: "md:w-28 lg:w-28 xl:w-32  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "City",
    key: "BookingPersonCity",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Person Address",
    key: "BookingPersonAddress",
    width: "md:w-44 lg:w-44 xl:w-44  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Source Type",
    key: "ReferralSource",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5  justify-right",
    width1: "text-red-500",
  },
  {
    title: "Source",
    key: "Source",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "ID-Proof",
    key: "IdProof",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "ID-Number",
    key: "IdNumber",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomTypes",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Room Names",
    key: "RoomNames",
    width: "md:w-28 lg:w-28 xl:w-28  justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Basic Tariff",
    key: "BookingBasicTariff",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Special Tariff",
    key: "BookingSpecialTariff",
    width: "md:w-36 lg:w-36 xl:w-36 whitespace-pre-line justify-left  2xl:w-36 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking No. Of Required Rooms",
    key: "BookingNoOfRequiredRooms",
    width: "md:w-36 lg:w-36 xl:w-36 whitespace-pre-line justify-left  2xl:w-36 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking No. Of Adults",
    key: "BookingNoOfAdults",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking No. Of Children",
    key: "BookingNoOfChildren",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Amount",
    key: "BookingAmount",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Booking Received Amount",
    key: "BookingReceivedAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Balance Amount",
    key: "BookingBalanceAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Payment Type",
    key: "BookingPaymentType",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Payment Reference Number",
    key: "BookingPaymentReferenceNumber",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Booking Status",
    key: "BookingStatus",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "CheckIn Date",
    key: "CheckInDate",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Guest Name",
    key: "GuestName",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Gender",
    key: "Gender",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Age",
    key: "Age",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Relationship",
    key: "Relationship",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "ID Proof Type",
    key: "IdProof",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "ID Proof Number",
    key: "IDProofNumber",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Photo",
    key: "Photo",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "CheckIn Additional Adults",
    key: "CheckInAdditionalAdults",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Additional Children",
    key: "CheckInAdditionalChildren",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Received Amount",
    key: "CheckInReceivedAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Balance Amount",
    key: "CheckInBalanceAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Payment Type",
    key: "CheckInPaymentType",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckIn Payment Reference Number",
    key: "CheckInPaymentReferenceNumber",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },

  {
    title: "Check Out Date",
    key: "CheckOutDate",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Check Out No. Of Available Rooms",
    key: "CheckOutNoOfAvailableRooms",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Check Out Basic Tariff",
    key: "CheckOutBasicTariff",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Check Out Special Tariff",
    key: "CheckOutSpecialTariff",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckOut No. Of Required Rooms",
    key: "CheckOutNoOfRequiredRooms",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "CheckOut No. Of Adults",
    key: "CheckOutNoOfAdults",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "Check Out No. Of Children",
    key: "CheckOutNoOfChildren",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   
   {
    title: "Check Out Any Damage",
    key: "CheckOutAnyDamage",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "Check Out Damage Description",
    key: "CheckOutDamageDescription",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "Check Out Damage Amount",
    key: "CheckOutDamageAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
 {
    title: "Check Out Amount",
    key: "CheckOutAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
   {
    title: "Check Out Received Amount",
    key: "CheckOutReceivedAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Check Out Balance Amount",
    key: "CheckOutBalanceAmount",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Check Out Payment Type",
    key: "CheckOutPaymentType",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Check Out Payment Reference Number",
    key: "CheckOutPaymentReferenceNumber",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
];
// const checkInReportHeaders = [
//   {
//     title: "S.No.",
//     width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Booking ID",
//     key: "BookingNo",
//     width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Booking Date",
//     key: "BookingDate",
//     width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Check-In Date",
//     key: "CheckInDate",
//     width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },

//   {
//     title: "Check-Out Date",
//     key: "CheckOutDate",
//     width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Type",
//     key: "EnquiryType",
//     width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Source Type",
//     key: "ReferralSource",
//     width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5 flex justify-right",
//     width1: "text-red-500",
//   },
//   {
//     title: "Guest Name",
//     key: "GuestName",
//     width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
//     width1: "text-red-500",
//   },
//   {
//     title: "Mobile Number",
//     key: "MobileNumber",
//     width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5 flex justify-right",
//     width1: "text-red-500",
//   },
//   {
//     title: "Revenue",
//     key: "TotalAmount",
//     width: "md:w-28 lg:w-28 xl:w-28 flex justify-left  2xl:w-28 py-1.5",
//     width1: "text-red-500",
//   },

//   {
//     title: "No Of Rooms Booked",
//     key: "NoOfRequiredBooked",
//     width:
//       "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
//   },
//   {
//     title: "No Of Days",
//     key: "NoOfDays",
//     width:
//       "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
//   },
//   {
//     title: "Room Types",
//     key: "RoomTypes",
//     width:
//       "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
//   },
//   {
//     title: "Room Names",
//     key: "RoomNames",
//     width:
//       "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
//   },
//   {
//     title: "Lost Reason",
//     key: "LostReason",
//     width:
//       "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
//   },
// ];
const stockLedgerReportHeaders = [
  {
    title: "S.No.",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Date",
    key: "Date",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  
  {
    title: "Txn Type",
    key: "TxnType",
    width: "md:w-60 lg:w-60 xl:w-60 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Qty.",
    key: "Qty",
    width: "md:w-40 lg:w-40  xl:w-40  flex justify-left  2xl:w-40  py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Balance",
    key: "Balance",
    width: "md:w-40  lg:w-40  xl:w-40   2xl:w-40  px-1 py-1.5 flex justify-right",
    width1: "text-red-500",
  },
 
];

const stockReportHeaders = [
  {
    title: "S.No.",
    width: "md:w-10 lg:w-10 xl:w-12 2xl:w-14 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Item Type",
    key: "ItemType",
    width: "md:w-40 lg:w-40 xl:w-40 whitespace-pre-line 2xl:w-40 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Category",
    key: "ItemCategory",
    width: "md:w-28 lg:w-28 xl:w-28 whitespace-pre-line 2xl:w-28 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Item Name",
    key: "ItemName",
    width: "md:w-36 lg:w-36 xl:w-36 2xl:w-36 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Opening Qty.",
    key: "OpeningQty",
    width: "md:w-28 lg:w-28 xl:w-28 flex justify-left  2xl:w-28 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Total Purchase",
    key: "TotalPurchase",
    width: "md:w-36 lg:w-36 xl:w-36  2xl:w-36 px-1 py-1.5 flex justify-right",
    width1: "text-red-500",
  },
  {
    title: "Total Receipt",
    key: "TotalReceipt",
    width: "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-1 py-1.5 ",
    width1: "text-red-500",
  },

  {
    title: "Total Issue",
    key: "TotalIssue",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Total Consumption",
    key: "TotalConsumption",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Total Damage",
    key: "TotalDamage",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
  {
    title: "Current Stock",
    key: "ClosingQty",
    width:
      "md:w-32 lg:w-32 xl:w-32 whitespace-pre-line 2xl:w-32 px-0.5 py-1.5 ",
  },
];
const issueView = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-10 lg:w-10 xl:w-10 2xl:w-10  px-1 py-1.5  ",
    width1: "text-red-500",
  },
  {
    title: "Item Type",
    key: "ItemType",
    width: "md:w-28 lg:w-60 xl:w-60 2xl:w-60 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Category",
    key: "ItemCategory",
    width: "md:w-40 lg:w-52 xl:w-52 2xl:w-60  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "Name",
    key: "ItemName",
    width: "md:w-48 lg:w-48 xl:w-60 2xl:w-60  px-1 py-1.5",
    width1: "text-red-500",
  },

  {
    title: "Quantity",
    key: "Quantity",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
  {
    title: "U.O.M",
    key: "UOM",
    width: "md:w-20 lg:w-20 xl:w-20 2xl:w-20  px-1 py-1.5",
    width1: "text-red-500",
  },
];
const complaintsHeader = [
  {
    title: "S.No.",
    key: "sno",
    width: "md:w-12 px-1 py-1.5 ",
    width1: "text-red-500",
  },
  {
    title: "Complaints No",
    key: "ComplaintsNo",
    width: "md:w-48 lg:w-52 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Complaints Date",
    key: "FormattedDate",
    width: "md:w-48 lg:w-52 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Room Type",
    key: "RoomType",
    width: "md:w-48 lg:w-52 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Room",
    key: "RoomName",
    width: "md:w-48 lg:w-52 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },
  {
    title: "Complaint Type",
    key: "ComplaintsType",
    width: "md:w-48 lg:w-52 xl:w-40 2xl:m-auto px-1 py-1.5 mr-auto",
    width1: "text-red-500",
  },

  {
    title: "Action",
    key: "action",
    width: " px-1.5 py-1.5 flex justify-center md:w-16",
  },
];

export {
  userHeaders,
  supplierMasterHeader,
  //customersMasterHeader,
  roleMasterHeader,
  customerMasterHeader,
  questionsMasterHeader,
  questionsDownloadHeader,
  reportCardMailMasterHeader,
  downloadQuestionsAnswerHeader,
  downloadAttachmentHeader,
  reportCardMailHeader,
  partnermapingHeader,
  moduleHeader,
  partnerMasterHeader,
  topicMasterHeader,
  paymentInfoHeader,
  tariffMasterHeader,
  holidayMasterHeader,
  consumptionHeader,
  ConsumptionViewHeaders,
  mappingroomtypewithtariff1,
  // itemcategoryHeader,

  // mappingroomtypewithtariff1,
  ItemCategoryHeader,
  SpaceTypeHeader,
  CountryMasterHeader,
  AttendanceHeader,

  // villaMasterHeaders,

  //villaTypeMasterHeader,

  // villaMasterHeaders,
  roomMasterHeader,
  roomTypeHeader,
  LaundryIssueHeader,
  LaundryReceiptHeader,

  //villaTypeMasterHeader,
  RoomTypeHeader,
  enquiryHeaders,
  reasonForLostHeader,
  itemsHeader,
  socialMarketingHeader,
  medicinesDrugsHeader,
  AmenitiesMasterHeader,
  LaundryCompanyHeader,
  consumablesHeader,
  StaffMasterHeader,
  shiftMasterHeader,
  cancellationHeaders,
  SalaryPayHeader,
  EnquirytobookingHeader,
  paymentHeader,
  GradeHeader,
  reasonForCancelHeader,
  SalaryMappingHeader,
  ComplaintsAndIssuesHeader,
  RevenueExpenseHeader,
  RevenueExpenseDetailsHeader,
  bookedHeader,
  checkOutHeader,
  checkOutHeader1,
  checkInHeader,
  checkInHeader1,
  maintenanceHeader,
  ReceiptsHeaders,
  DamagesHeader,
  openingStockHeader,
  SalaryPaidHeader,
  staffsalaryHeader,
  PayrollHeader,
  laundryHeader,
  BookingDetailsHeaders,
  mappingroomtype,
  PaymentInfoHeader,
  mappingroomtypewithamenities,
  mappingroomtypewithSpaces,
  stateMasterHeader,
  locationMasterHeader,
  enquiryLostHeaders,
  PurchaseHeaders,
  clientsHeader,
  invoicesHeader,
  popupUserHeader,
  foodsAndBeveragesHeader,
  HouseKeepingHeader,
  issueHeader,
  issueView,
  DamagespopupHeader,
  damagesHeader,
  CityHeader,
  LaundryIssueView,
  LaundryReceiptView,
  ItemPopupHeader,
  IssueItemPopupHeader,
  bookingEnquiryHeaders,
  ConsumptionHeaders,
  ConsumptionView,
  LaundryReciptIssueHeader,
  LaundryViewReceipt,
  ReceiptView,
  enquiryReportHeaders,
  checkInReportHeaders,
  checkOutReportHeaders,
  stockReportHeaders,
  bookingReportHeaders,
  stockLedgerReportHeaders,
  BookingDetailsHeaders1,
  complaintsHeader,
  SourceTypeHeader,
  ComplaintsListHeader,
  PositionHeader
};
